import rimg from '@pixelunion/rimg-shopify';

export default class ProductSlideshow {
  constructor({ el }) {
    this.el = el;
    this.productGalleryNavigationPrevious = this.el.querySelector('.product-thumbnails-navigation-previous');
    this.productGalleryNavigationNext = this.el.querySelector('.product-thumbnails-navigation-next');
    this.productGalleryNavigationWrapper = this.el.querySelector('.product-gallery--navigation-wrapper');
    this.productGalleryNavigation = this.el.querySelector('.product-gallery--navigation');
    this.productGalleryMediaThumbnails = this.el.querySelectorAll('.product-gallery--media-thumbnail');

    if (this.productGalleryNavigationPrevious) {
      this.productGalleryNavigationPrevious.addEventListener('click', event => this.moveProductThumbnails(event));
    }

    if (this.productGalleryNavigationNext) {
      this.productGalleryNavigationNext.addEventListener('click', event => this.moveProductThumbnails(event));
    }

    this.moving = false;

    if (this.productGalleryNavigation) {
      rimg.watch(this.productGalleryNavigation);

      if (this.productGalleryNavigation.classList.contains('has-side-scroll')) {
        this.setupProductSlideshow();
        this.productGalleryNavigation.addEventListener('rimg:load', () => { this.setupProductSlideshow(); });

        window.addEventListener('resize', () => {
          const selectedThumbnail = this.el.querySelector('[data-product-gallery-selected="true"]');
          this.setupProductSlideshow(true);
          if (selectedThumbnail) {
            this.selectThumbnail(selectedThumbnail.dataset.media);
          } else {
            this.productGalleryNavigation.style.left = 0;
          }
        });
      }
    }
  }

  setupProductSlideshow() {
    let tallestImageHeight = 0;
    let containerWidth = 0;

    this.productThumbnailPadding = parseInt(window.getComputedStyle(this.productGalleryMediaThumbnails[0]).paddingLeft, 10) * 2;
    this.productThumbnailMargin = parseInt(window.getComputedStyle(this.productGalleryMediaThumbnails[0]).marginRight, 10) * 2;

    this.productGalleryMediaThumbnails.forEach(productGalleryMediaThumbnail => {
      productGalleryMediaThumbnail.style.width = `${((this.productGalleryNavigationWrapper.getBoundingClientRect().width / 4) - this.productThumbnailPadding - this.productThumbnailMargin)}px`;

      const currentImageHeight = productGalleryMediaThumbnail.getBoundingClientRect().height;
      let currentImageWidth = productGalleryMediaThumbnail.getBoundingClientRect().width + this.productThumbnailMargin;

      if (currentImageHeight > tallestImageHeight) {
        tallestImageHeight = currentImageHeight;
      }

      containerWidth += currentImageWidth;
    });

    this.productGalleryNavigationWrapper.style.height = `${tallestImageHeight}px`;
    this.productGalleryNavigation.style.width = `${containerWidth}px`;
  }

  moveProductThumbnails(e) {
    const { width: containerWidth } = this.productGalleryNavigationWrapper.getBoundingClientRect();
    const { offsetLeft: currentPosition, offsetWidth: totalWidth } = this.productGalleryNavigation;
    const rightEdge = -(totalWidth - containerWidth);
    const leftEdge = 0;
    let distance;

    if (e.currentTarget.classList.contains('product-thumbnails-navigation-next') && ((currentPosition - containerWidth) > -(this.productGalleryNavigation.getBoundingClientRect().width))) {
      distance = currentPosition - containerWidth > rightEdge
        ? currentPosition - containerWidth
        : rightEdge;
    } else if (e.target.classList.contains('product-thumbnails-navigation-previous') && (currentPosition < 0)) {
      distance = currentPosition + containerWidth < leftEdge
        ? currentPosition + containerWidth
        : leftEdge;
    }

    this.productGalleryNavigation.style.left = `${distance}px`;
  }

  selectThumbnail(mediaId) {
    if (!this.productGalleryNavigation) return;

    const thumbnail = this.productGalleryNavigation.querySelector(`[data-media="${mediaId}"]`);
    const thumbnailIndex = thumbnail.dataset.productGalleryThumbnail;
    const slides = Math.floor(thumbnailIndex / 4);
    const containerWidth = this.productGalleryNavigationWrapper.getBoundingClientRect().width;
    const newPosition = -(containerWidth * slides);

    this.productGalleryNavigation.style.left = `${newPosition}px`;
  }
}
